import { Form, Modal, Typography } from 'antd';
import Button from '../../UI/Button/Button';
import React from 'react';
import Input from '../../UI/Input/Input';
import PasswordInput from '../../UI/Input/PasswordInput';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const SignInModal = ({
  open,
  onClose,
  onSubmit,
  onSignUp,
  onChange,
  isValid,
  form,
  onForgotPassword,
  loading
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 1000
          }}
        >
          <Spin
            indicator={<LoadingOutlined spin />}
            style={{ height: 'fit-content' }}
          />
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          alignItems: 'center',
          marginTop: 50,
          width: '100%'
        }}
      >
        <h2 style={{ textAlign: 'center' }}>{t('modals.signIn.title')}</h2>
        <Typography style={{ marginTop: 20, fontSize: 20, fontWeight: 400, textAlign: 'center' }}>
          {t('modals.signIn.noAccount')}
        </Typography>
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 400,
            textDecoration: 'underline',
            color: '#9989C7',
            cursor: 'pointer'
          }}
          onClick={onSignUp}
        >
          {t('button.signUp')}
        </Typography>
        <Form
          form={form}
          layout='vertical'
          onFinish={onSubmit}
          style={{ marginTop: 40, width: '100%' }}
          onFieldsChange={onChange}
        >
          <Form.Item
            name='email'
            rules={[{ required: true, message: t('schema.required') }]}
          >
            <Input size='large' placeholder={t('input.email')} />
          </Form.Item>

          <Form.Item
            name='password'
            rules={[{ required: true, message: t('schema.required') }]}
          >
            <PasswordInput placeholder={t('input.password')} />
          </Form.Item>

          <Button
            wide
            style={{ marginBottom: 20 }}
            disabled={!isValid}
            onClick={form.submit}
          >
            {t('button.signIn')}
          </Button>
        </Form>
        <Typography
          style={{ fontSize: 20, fontWeight: 400, cursor: 'pointer' }}
          onClick={onForgotPassword}
        >
          {t('modals.signIn.forgotPassword')}
        </Typography>
      </div>
    </Modal>
  );
};

export default SignInModal;
